import { connect } from 'react-redux'
import UI from './UI'

const mapStateTopProps = ({ referential, user, course }) => ({
  ProfileType: referential?.ProfileTypes ? referential?.ProfileTypes[user?.ProfileType] : null,
  Title: course.Course.Title,
  Subtitle: course.Course.Subtitle,
  PricePromo: course.Course.PricePromo,
  AlternativePricePromo: course.Course.AlternativePricePromo,
  loading: course.gettingCoursesInfos,
  IsFree: course.Course.IsFree,
  IsNew: course.Course.IsNew
})

export default connect(mapStateTopProps, null)(UI)
